import React from "react";

interface CaseSummaryPanelProps {
  formData: Record<string, string>;
  recommendations: any;
}

export const CaseSummaryPanel: React.FC<CaseSummaryPanelProps> = ({
  formData,
  recommendations,
}) => {
  const age = formData["Age"] || formData["age"] || "—";
  const menoStatus =
    formData["Menopausal Status"] || formData["menopausalStatus"] || "—";
  const grade = formData["Grade"] || "—";
  const erStatus = formData["ER status"] || formData["er"] || "—";
  const her2Status = formData["HER2 status"] || formData["her2"] || "—";
  const invasiveSize =
    formData["Invasive tumor size (mm)"] ||
    formData["invasiveTumourSize"] ||
    "—";
  const lymphNodes =
    formData["Number of positive lymph nodes"] || formData["lymphNodes"] || "—";
  const surgery = formData["Surgery"] || formData["surgery"] || "—";

  const laterality = formData["Laterality"] || "Breast Cancer";

  const diagnosisText = `(${laterality}) Breast Cancer - Grade ${grade}, ER: ${erStatus}, HER2: ${her2Status}, Invasive size: ${invasiveSize}mm, Lymph nodes: ${lymphNodes}`;
  const backgroundText = `Age: ${age}, Menopausal status: ${menoStatus}`;
  const treatmentHistoryText = `Surgery: ${surgery}`;

  return (
    <div className="flex-1 bg-blue-700 text-white p-4 overflow-y-auto">
      <h3 className="font-bold text-sm mb-3">Case Summary:</h3>

      <div className="space-y-4 text-xs">
        <div>
          <div className="font-semibold text-blue-200 mb-1">Diagnosis:</div>
          <p className="text-white leading-relaxed">{diagnosisText}</p>
        </div>

        <div>
          <div className="font-semibold text-blue-200 mb-1">Background:</div>
          <p className="text-white leading-relaxed">{backgroundText}</p>
        </div>

        <div>
          <div className="font-semibold text-blue-200 mb-1">
            Treatment History:
          </div>
          <p className="text-white leading-relaxed">{treatmentHistoryText}</p>
        </div>

        {recommendations && (
          <div>
            <div className="font-semibold text-blue-200 mb-1">
              Proposed treatment:
            </div>
            <div className="space-y-1 text-white">
              {recommendations.staging && <p>1. {recommendations.staging}</p>}
              {recommendations.chemotherapy?.length > 0 && (
                <p>2. {recommendations.chemotherapy[0]}</p>
              )}
              {recommendations.endocrineTherapy?.length > 0 && (
                <p>3. {recommendations.endocrineTherapy[0]}</p>
              )}
              {recommendations.radiotherapy?.length > 0 && (
                <p>4. {recommendations.radiotherapy[0]}</p>
              )}
            </div>
          </div>
        )}

        {formData["caseSummary"] && (
          <div className="mt-3 p-2 bg-blue-600 rounded-lg">
            <pre className="whitespace-pre-wrap text-xs text-blue-100">
              {formData["caseSummary"]}
            </pre>
          </div>
        )}
      </div>
    </div>
  );
};
